import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { AppData } from '../AppData';
import { CompoApp } from '../CompoApp';
import { UrlBuilder } from '../../models/frontend_entities/UrlBuilder';
import Constants from '../../Constants';
import { ModuleAttributeGroupDto } from '../../models/module_attribute_group/ModuleAttributeGroupDto';
import { ModuleAttributeGroupSaveAllDto } from '../../models/module_attribute_group/ModuleAttributeGroupSaveAllDto';

@Injectable({
  providedIn: 'root'
})
export class ModuleAttributeGroupRequestService {

  //region INJECTIONS
  private readonly data: AppData = inject(CompoApp).data;
  private readonly http: HttpClient = inject(HttpClient);
  //endregion

  //region GET
  public getForClass(classId: string): Observable<ModuleAttributeGroupDto[]> {
    const url: string = new UrlBuilder(
      Constants.URLS.moduleAttributeGroup.forClass.replace('{classId}', classId)
    )
      .param('accessMode', this.data.getAccessMode())
      .build();

    return this.http.get<ModuleAttributeGroupDto[]>(url).pipe(take(1));
  }

  public getForComponentClassGroup(componentClassGroupId: string): Observable<ModuleAttributeGroupDto[]> {
    const url: string = new UrlBuilder(
      Constants.URLS.moduleAttributeGroup.forComponentClassGroup.replace('{componentClassGroupId}', componentClassGroupId)
    )
      .param('accessMode', this.data.getAccessMode())
      .build();

    return this.http.get<ModuleAttributeGroupDto[]>(url).pipe(take(1));
  }
  //endregion

  //region PUT
  public saveAll(dto: ModuleAttributeGroupSaveAllDto): Observable<void> {
    const url: string = new UrlBuilder(
      Constants.URLS.moduleAttributeGroup.saveAll
    )
      .param('accessMode', this.data.getAccessMode())
      .build();

    return this.http.put<void>(url, dto).pipe(take(1));
  }
  //endregion
}
